import {BaseUtils} from "./base-utils";

export class DomUtils extends BaseUtils {
  container;

  static injectables = [];

  constructor(document = window.document) {
    super();

    this.container = null;
    this.document = document;
  }

  get containerDimentions() {
    return this.container && this.container.getBoundingClientRect();
  }

  get height() {
    return this.container.offsetHeight;
  }

  get offsetHeight() {
    return window.pageYOffset + this.containerDimentions.y;
  }

  get offsetLeft() {
    return this.container.offsetLeft;
  }

  onAppPageHide(callback: (event: PageTransitionEvent) => void) {
    this.createEvent('pagehide', callback);
  }

  onAppFocus(callback) {
    this.createEvent('focus', callback);
  }

  removeOnAppFocus(callback) {
    this.removeEvent('focus', callback);
  }

  onAppBlur(callback) {
    this.createEvent('blur', callback);
  }

  setDirection(dir) {
    this.container.dir = dir;
  }

  blockScrolling(block: Boolean) {
    const blockClassName: String = 'body-block';

    this.removeBodyClassName(blockClassName);

    if(block) {
      this.addBodyClass(blockClassName);
    }
  }

  blockScrollToTop(block: Boolean) {
    const blockClassName: String = 'body-block-scroll-to-top';

    this.removeBodyClassName(blockClassName);

    if(block) {
      this.addBodyClass(blockClassName);
    }
  }

  scrollToTop(scrollContainer: Boolean = false) {
    scrollContainer ? this.container.scrollTo(0 ,0) : this.container.scrollIntoView();
  }

  scrollWidgetToTop() {
    this.container.scrollTo(0 ,0);
  }

  jumpToTop() {
    window.document.documentElement.scrollTop = 0
  }

  createEvent(eventName, callback, options = null) {
    window.addEventListener(eventName, callback,  options);
  }

  removeEvent(eventName, callback, options = null) {
    window.removeEventListener(eventName, callback, options);
  }

  getElementByDataAttribute(dataAttribute: String, data) {
    const element: Array<Element> = this.document.querySelectorAll(`[data-${dataAttribute}='${data}']`);

    return element.length > 0 ? element[0] : null;
  }

  scrollToElement(element: Element) {
    if (!element) {
      return;
    }

    const top: Number = element.centerVerticalPosition();

    window.scrollTo(0, top);
  }

  addScriptTag(url: String) {
    const tag: Element = this.document.createElement("script");
    tag.src = url;
    this.document.body.appendChild(tag);
  }

  cancelAnimationFrame(animationFrameId: Number) {
    window.cancelAnimationFrame(animationFrameId);
  }

  requestAnimationFrame(frameFunc: Function): Number {
    return window.requestAnimationFrame(frameFunc);
  }

  createViewportObserver(config, onEnter, observeOnce) {
    return new IntersectionObserver(function (entries, self) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          onEnter(entry.target);
          observeOnce && self.unobserve(entry.target);
        }
      });
    }, config);
  }

  appendScriptToElement(elementId: String, script: String) {
    const element = this.document.getElementById(elementId);

    if (element) {
      const scriptTag = this.document.createElement("script");
      scriptTag.innerHTML = script;
      element.appendChild(scriptTag);
    }
  }

  setContainerClass(className) {
    this.container.className = className;
  }

  // removeContainerClass(className) {
  //   this.container.classList.remove(className);
  // }

  removeBodyClassName(className) {
    document.body.classList.remove(className);
  }

  addBodyClass(className) {
    const hasClassName = document.body.classList.contains(className);

    if (!hasClassName) {
      document.body.classList.add(className);
    }
  }


  removeBodyClass(className) {
    const hasClassName = document.body.classList.contains(className);

    if (!hasClassName) {
      document.body.classList.remove(className);
    }
  }

  getBlobUrl(url) {
    const content = `importScripts( "${url}" );`;
    return URL.createObjectURL(new Blob([content], {type: "text/javascript"}));
  }
}
